import React from "react";

const PageHeader = ({ title, subtitle, className = "" }) => {
  const titleSpacing = subtitle ? "mb-1" : "mb-0"; // 4px when subtitle exists

  return (
    <div className={`flex flex-col items-start ${className}`}>
      {title && (
        <h1
          className={`font-inter text-[22px] leading-[28px] font-semibold text-gray-900 text-left ${titleSpacing}`}
        >
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="font-inter text-[14px] leading-5 font-normal text-left m-0" style={{ color: "#667085" }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageHeader;
